import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

async function getB2CServiceHistoriesRequestQuery(
  apiClient: ApiClient,
  filter: { searchString?: string; page?: number; itemsPerPage?: number; status?: string; user_id?: number; make_id?: number },
) {
  return apiClient.GET(`/op/v2/b2c-service-history-request`, { params: { query: filter } });
}

export default function useB2CServiceHistoriesRequestQuery(filter: {
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  status?: string;
  user_id?: number;
  make_id?: number;
}) {
  const toast = useToast();
  const apiClient = useApiClient();

  const query = useQuery({
    queryKey: getKey(filter),
    queryFn: () => throwOnError(getB2CServiceHistoriesRequestQuery(apiClient, filter)),
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(filter: {
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  status?: string;
  user_id?: number;
  make_id?: number;
}): QueryKey {
  return ['B2CServiceHistoriesRequest', filter] as const satisfies QueryKey;
}

useB2CServiceHistoriesRequestQuery.getKey = getKey;
